
// Pushed from a group header's plus button: pick a report and the
// presentation kind, ADD instantiates it in that group and pops back.
// Everything stays inside the editor's navigation popover — presenting an
// alert from here dismisses the popover and loses the un-applied edits.
class DashboardAddWidgetViewController extends MUIViewController
{
    static newInstance() : DashboardAddWidgetViewController {
        let vc = new DashboardAddWidgetViewController("dashboard-add-widget-view");
        vc.initWithResource("layout/reports/DashboardAddWidgetView.html");
        return vc;
    }

    get preferredContentSize(): MIOSize {
        return new MIOSize(420, 560);
    }

    editor:DashboardEditViewController = null;

    private reportComboBox:MUIComboBox = null;
    private typeComboBox:MUIComboBox = null;

    viewDidLoad() {
        let backButton = MUIOutlet(this, "back-btn", "MUIButton");
        backButton?.setAction(this, function(this:DashboardAddWidgetViewController){
            this.navigationController?.popViewController(true);
        });

        let addButton = MUIOutlet(this, "add-btn", "MUIButton");
        addButton?.setAction(this, function(this:DashboardAddWidgetViewController){
            this.editor?.addWidget(this._groupIndex, this.reportComboBox.getSelectedItem(), this.typeComboBox.getSelectedItem());
            this.navigationController?.popViewController(true);
        });

        this.reportComboBox = MUIOutlet(this, "report-cb", "MUIComboBox");
        this.reportComboBox.setOnChangeAction(this, function(this:DashboardAddWidgetViewController, control, value:string){
            this.fillKinds(value);
        });

        this.typeComboBox = MUIOutlet(this, "type-cb", "MUIComboBox");

        this.updateUI();
    }

    viewWillAppear(animated?:any): void {
        super.viewWillAppear(animated);
        this.updateUI();
    }

    private _groupIndex = -1;
    private catalogWidgets:any[] = [];
    setContext(editor:DashboardEditViewController, groupIndex:number, catalogWidgets:any[]){
        this.editor = editor;
        this._groupIndex = groupIndex;
        this.catalogWidgets = catalogWidgets ?? [];
        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false) return;

        this.reportComboBox.removeAllItems();
        for (let widget of this.catalogWidgets) {
            let title = widget["Title"] ?? widget["ID"];
            this.reportComboBox.addItem(MIOLocalizeString(title, title), widget["ID"]);
        }
        if (this.catalogWidgets.length > 0) {
            let first = this.catalogWidgets[0]["ID"];
            this.reportComboBox.selectItem(first);
            this.fillKinds(first);
        }
    }

    private fillKinds(widgetID:string){
        this.typeComboBox.removeAllItems();
        let widget = null;
        for (let w of this.catalogWidgets) { if (w["ID"] == widgetID) { widget = w; break; } }
        if (widget == null) return;
        for (let kind of (widget["SupportedKinds"] ?? [widget["Kind"]])) {
            let title = kind.toUpperCase();
            this.typeComboBox.addItem(MIOLocalizeString(title, title), kind);
        }
        this.typeComboBox.selectItem(widget["Kind"]);
    }
}
